import Vue from 'vue'
import { utils } from '@/utils'
import { constants } from '@/constants'
Vue.prototype.$utils = utils
Vue.prototype.$constants = constants

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import '@/components/_globals'
import '@/components/highcharts'

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
  async beforeMount() {}
})

app.$mount('#app')
